import I18n from '../../config/locales';

export const ADMIN_PANEL_REQUEST = 'ADMIN_PANEL_REQUEST';
export const ADMIN_PANEL_SUCCESS = 'ADMIN_PANEL_SUCCESS';
export const ADMIN_PANEL_FAILURE = 'ADMIN_PANEL_FAILURE';
export const ADMIN_DETAILS_REQUEST = 'ADMIN_DETAILS_REQUEST';
export const ADMIN_DETAILS_FAILURE = 'ADMIN_DETAILS_FAILURE';
export const ADMIN_DETAILS_CREATE_REQUEST = 'ADMIN_DETAILS_CREATE_REQUEST';
export const ADMIN_DETAILS_CREATE_SUCCESS = 'ADMIN_DETAILS_CREATE_SUCCESS';
export const ADMIN_DETAILS_CREATE_FAILURE = 'ADMIN_DETAILS_CREATE_FAILURE';
export const ADMIN_DETAILS_UPADTE_REQUEST = 'ADMIN_DETAILS_UPADTE_REQUEST';
export const ADMIN_DETAILS_UPADTE_SUCCESS = 'ADMIN_DETAILS_UPADTE_SUCCESS';
export const ADMIN_DETAILS_UPADTE_FAILURE = 'ADMIN_DETAILS_UPADTE_FAILURE';
export const ADMIN_DETAILS_DELETE_REQUEST = 'ADMIN_DETAILS_DELETE_REQUEST';
export const ADMIN_DETAILS_DELETE_SUCCESS = 'ADMIN_DETAILS_DELETE_SUCCESS';
export const ADMIN_DETAILS_DELETE_FAILURE = 'ADMIN_DETAILS_DELETE_FAILURE';
export const PRODUCT_ACCESS_REQUEST = 'PRODUCT_ACCESS_REQUEST';
export const PRODUCT_ACCESS_SUCCESS = 'PRODUCT_ACCESS_SUCCESS';
export const PRODUCT_ACCESS_FAILURE = 'PRODUCT_ACCESS_FAILURE';
export const DIGITAL_ASSETS_SUCCESS = 'DIGITAL_ASSETS_SUCCESS';
export const PRODUCT_INFO_SUCCESS = 'PRODUCT_INFO_SUCCESS';
export const EXCLUSIVE_SUCCESS = 'EXCLUSIVE_SUCCESS';
export const HEADER_LINK_SUCCESS = 'HEADER_LINK_SUCCESS';
export const UPLOAD_EIN_FILE_REQUEST = 'UPLOAD_EIN_FILE_REQUEST';
export const UPLOAD_EIN_FILE_SUCCESS = 'UPLOAD_EIN_FILE_SUCCESS';
export const UPLOAD_EIN_FILE_FAILURE = 'UPLOAD_EIN_FILE_FAILURE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const SAMPLE_DATA_REQUEST = 'SAMPLE_DATA_REQUEST';
export const SAMPLE_DATA_SUCCESS = 'SAMPLE_DATA_SUCCESS';
export const SAMPLE_DATA_FAILURE = 'SAMPLE_DATA_FAILURE';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';
export const PUT_EIN_S3_URL_REQUEST = 'PUT_EIN_S3_URL_REQUEST';

export const UPLOAD_ERROR_MESSAGE = {
  EMPTY_FILE: I18n.t('adminPanel.empty_file'),
  INVALID_FILE_FORMAT: I18n.t('adminPanel.invalidFileFormat'),
  INVALID_FILE_HEADERS: I18n.t('adminPanel.invalidFileHeader'),
  SUCCESS: I18n.t('adminPanel.uploadFailed'),
  INVALID_FILE: I18n.t('adminPanel.invalidFile')
};
export const GET_ENLM_FEEDBACK_CSV_DATA_REQUEST = 'GET_ENLM_FEEDBACK_CSV_DATA_REQUEST';
export const GET_ENLM_FEEDBACK_CSV_DATA_SUCCESS = 'GET_ENLM_FEEDBACK_CSV_DATA_SUCCESS';
export const GET_ENLM_FEEDBACK_CSV_DATA_FAILURE = 'GET_ENLM_FEEDBACK_CSV_DATA_FAILURE';
